<template>
  <Modal v-model="show" :width="700" :mask-closable="false"  @on-ok="ok" :loading="loading">
    <div slot="header" class="modal-header">编辑房间标签</div>
    <Row v-if="labelEntities.length === 0">暂无可编辑标签，快去配置房间标签吧</Row>
     <Form
			class="repeatForm"
			:ref="'form'+index"
			:rules="ruleValidate"
			:label-width="110"
      v-for="(itemP,index) in labelEntities"
			:key="'index2'+index"
			:model="itemP"
			>
      <Row >
				<Col span="10">
					<FormItem prop="labelName" label="标签名称">
						<Input v-model="itemP.labelName" placeholder="请输入标签名称"></Input>
					</FormItem>
				</Col>
				<Col span="10">
					<FormItem prop="labelOrder" label="显示顺序">
						<Input v-model="itemP.labelOrder" placeholder="请输入大于0的整数"></Input>
					</FormItem>
				</Col>
      </Row>
      <Row>
        <Col span="10">
          <FormItem prop="labelIsValidBol" label="是否停用">
            <i-switch v-model="itemP.labelIsValidBol">
								<span slot="open">是</span>
								<span slot="close">否</span>
						</i-switch>
          </FormItem>
        </Col>
      </Row>
     </Form>
     <Row>
			<Col span="4">
				<a style="line-height:32px;margin-left:10px" @click.stop="addItem"> + 继续添加</a>
			</Col>
		</Row>
  </Modal>
</template>

<script>
import { labelList , saveOrEdit } from 'api/labelmanage'
export default {
  name:'EditLabels',
  props:{
    n:{
      type:Number,
      default:0
    },
    stockFid: {
      type: String,
      default: ''
    }
  },
  data(){
    const validates = (rule, value, callback) => {
			const pattern = /^\+?[1-9]\d*$/
			if (!pattern.test(value)) {
				callback(new Error('请填写显示顺序且为大于0的整数'));
			} else {
				callback();
			}
		};
    return{
      show: false,
      loading: true,
      labelEntities: [],
      ruleValidate:{
        labelName:[
          { required: true, message: '请输入标签名', trigger: 'blur',type:'string'}
				],
        labelOrder:[
          { required: true, message: '请输入大于0的整数', trigger: 'blur',type:'number',validator: validates}
        ],
			},
    }
  },
  watch:{
    n(){
      if(this.$refs['form0']){
        if(this.$refs['form0'][0]) {
          this.$refs['form0'][0].resetFields()
        }
      }
      this.getLabels();
      this.show = true
    }
  },
  methods:{
    getLabels(){
      labelList({
        moduleFid:this.stockFid,
        type:5,
      })
      .then(res => {
        this.labelEntities = res.data;
        this.labelEntities.forEach(ele=>{
          ele.labelIsValidBol = false
        })
      })
    },
    addItem(){
      this.labelEntities.push(
        {
          labelType:5,
          labelSecondaryType:7,
          labelName:'',
          labelOrder:'',
          labelIsValidBol:false,
        }
      )
    },
    ok(){
      if(this.labelEntities.length === 0) {
        this.show = false;
        return
      }
      let validate = true
      for (const i in this.$refs) {
        if(this.$refs[i] instanceof Array){
          this.$refs[i].forEach(item => {
            item.validate(bool => {
              !bool && (validate = bool)
            })
          })
        }
      }
      if (!validate) {
        this.changeLoading()
        return
      }
      this.labelEntities.forEach(ele => {
        ele.labelIsValidBol === false ? ele.labelIsValid = 1 :ele.labelIsValid = 0
      })
      const params = {
        applyType:4,
        labelEntities:this.labelEntities,
        stockFids: [this.stockFid],
      }
      saveOrEdit(params)
			.then(res=>{
				if(res.code === 0){
					this.$emit('refresh')
					this.$Message.success('保存成功')
				}
			})
			.catch(()=>{
				return
			})
			.finally(()=>{
				this.show = false;
			})
    },
    changeLoading(){
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true
      })
    },
  }
}
</script>

<style scoped>
.repeatForm{
		padding-top: 24px;
		width: 100%;
		height: auto;
		border: 1px dashed darkgrey;
		margin-bottom: 20px;
	}
</style>